import { Box, Chip, Divider, Stack, Typography } from "@mui/material";

import { MechanicalResultsContent } from "@/pages/lab/chemistries/components/MechanicalResultsContent";
import { CampaignResponse } from "@/pages/mill/schedule/models/CampaignReponse";
import { MILLS, MillId } from "@/setup/mill-config/mill-config";
import { ChemistryResultsContent } from "./ChemistryResultsContent";

type Props = {
	heat: CampaignResponse | null;
	millId: MillId | null;
	canEdit?: boolean;
};

const SectionTitle = ({ children }: { children: string }) => (
	<Typography variant="subtitle2" fontWeight={600} color="text.secondary">
		{children}
	</Typography>
);

export const HeatDetailsPanel = ({ heat, millId, canEdit = false }: Props) => {
	if (!heat) {
		return (
			<Stack
				alignItems="center"
				justifyContent="center"
				sx={{ height: "100%", p: 3 }}
			>
				<Typography variant="body2" color="text.secondary">
					Select a heat to see its chemistry and mechanical tests
				</Typography>
			</Stack>
		);
	}

	return (
		<Stack sx={{ height: "100%", minHeight: 0 }}>
			<Box sx={{ px: 2, pt: 2, pb: 1 }}>
				<Stack
					direction="row"
					spacing={1}
					alignItems="baseline"
					flexWrap="wrap"
					useFlexGap
				>
					<Typography variant="h6" fontWeight={600}>
						{`Heat ${heat.HeatName ?? "-"}`}
					</Typography>
					{millId && (
						<Chip
							label={MILLS[millId].name}
							size="small"
							sx={{ height: 20, fontSize: "0.65rem", fontWeight: 600 }}
						/>
					)}
					<Typography variant="body2" color="text.secondary">
						{`Grade: ${heat.GradeName ?? "-"}`}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{`Section: ${heat.SectionName ?? "-"}`}
					</Typography>
				</Stack>
			</Box>

			<Box sx={{ flex: 1, minHeight: 0, overflow: "auto", px: 2, pb: 2 }}>
				<Stack spacing={1}>
					<SectionTitle>Chemistry</SectionTitle>
					<ChemistryResultsContent heat={heat} />

					<Divider sx={{ pt: 1 }} />

					<Box pt={1}>
						<SectionTitle>Mechanical Tests</SectionTitle>
					</Box>
					<MechanicalResultsContent
						heat={heat}
						millId={millId ?? undefined}
						canEdit={canEdit}
					/>
				</Stack>
			</Box>
		</Stack>
	);
};
